module.exports = __webpack_public_path__ + "static/media/adventure.998e4120.svg";